import * as React from "react";
import { observable, action } from "mobx";
import { observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { IMonth } from "../../../models/localization";
import { Grid, Row, Col } from "react-flexbox-grid";
import Select from "material-ui/Select";
import { FormControl, FormControlLabel } from "material-ui/Form";
import Input, { InputLabel } from "material-ui/Input";
import CheckBox from "material-ui/Checkbox";
import { MenuItem } from "material-ui/Menu";
import * as s from "./picker.css";

export enum MMYYPickValue {
  Month = 1,
  Year = 2,
  FromMon = 3,
  FromYear = 4,
  ToMon = 5,
  ToYear = 6,
  Current = 7
}
@observer
export class MMYYPicker extends React.Component<{ store: SeekerStore, title?: string, label?: string, fwd: boolean, mon: number, yr: number, currentLabel?:string, current?:boolean, onChange: (v: number, fmt: MMYYPickValue) => void }, {}> {
  @observable mon: number;
  @observable yr: number;
  @observable isCurrent: boolean;
  constructor(props: any) {
    super(props);
    this.initProps(props);
  }
  componentWillReceiveProps(props: any) {
    this.initProps(props);
  }
  @action initProps(props: any) {
    this.mon = props.mon;
    this.yr = props.yr;
    this.isCurrent = props.current || false;
  }
  @action setCurrent = (evt: any, chk: boolean): void => {
    this.isCurrent = chk;
    if (this.isCurrent) {
      const dt: Date = new Date();
      this.yr = dt.getFullYear();
      this.mon = dt.getMonth() + 1;
      this.props.onChange(this.mon, MMYYPickValue.ToMon);
      this.props.onChange(this.yr, MMYYPickValue.ToYear);
    }
    this.props.onChange(this.isCurrent ? 1 : 0, MMYYPickValue.Current);
  }
  private getMonths(): JSX.Element[] {
    const months: JSX.Element[] = [];
    this.props.store.localization.fields.months.map((m: IMonth, i: number): void => {
      months.push(<MenuItem key={i} value={m.ndx}>{m.mon}</MenuItem>);
    });
    return months;
  }
  private getYears(): JSX.Element[] {
    const yrs: JSX.Element[] = [];
    let start: number = 0;
    let end: number = 0;
    if (this.props.fwd) {
      start = new Date().getFullYear();
      end = start + 30;
      for (let i: number = start; i <= end; ++i) {
        yrs.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
      }
    } else {
      start = new Date().getFullYear();
      end = start - 50;
      for (let i: number = start; i >= end; --i) {
        yrs.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
      }
    }
    return yrs;
  }
  @action onChangeMon = (evt: any): void => {
    this.mon = evt.target.value;
    this.props.onChange(this.mon, MMYYPickValue.ToMon);
  }
  @action onChangeYear = (evt: any): void => {
    this.yr = evt.target.value;
    this.props.onChange(this.yr, MMYYPickValue.ToYear);
  }
  render(): JSX.Element {
    const checked: any = { color: "#5B6770" };
    const bold: any = { fontWeight: 600 };
    return (
      <div>
        {this.props.title && <p className={s.smallText}>{this.props.title}</p>}
     <Row className={s.row}>
          <Col xs={6} sm={3}>
        <FormControl>
              {this.props.label && <InputLabel htmlFor="mon">{this.props.label}</InputLabel>}
          <Select input={<Input id="mon" />} value={this.mon} onChange={this.onChangeMon}>
            {this.getMonths()}
          </Select>
        </FormControl>
      </Col>
          <Col xs={6} sm={3}>
        <FormControl>
              {this.props.label && <InputLabel htmlFor="yr">&nbsp;</InputLabel>}
          <Select input={<Input id="yr" />} value={this.yr} onChange={this.onChangeYear}>
            {this.getYears()}
          </Select>
        </FormControl>
      </Col>
      </Row>
        {this.props.currentLabel && <Row className={s.row}>
          <Col xs={12}>
            <FormControlLabel style={bold} label={this.props.currentLabel}
                  control={<CheckBox style={checked} checked={this.isCurrent} color="secondary"
                      onChange={this.setCurrent} />} />
          </Col>
      </Row>}
     </div>);
  }
}

@observer
export class MMYYRangePicker extends React.Component<{ store: SeekerStore, title?: string, fromLabel: string, toLabel: string, currentLabel: string, fwd: boolean, current?: boolean, fromMon: number, fromYr: number, toMon: number, toYr: number, onChange: (v: number, fmt: MMYYPickValue) => void }, {}> {
  @observable fromMon: number;
  @observable fromYr: number;
  @observable toMon: number;
  @observable toYr: number;
  @observable isCurrent: boolean;
  constructor(props: any) {
    super(props);
    this.initProps(props);
  }
  componentWillReceiveProps(props: any): void {
    this.initProps(props);
  }
  @action initProps(props:any) {
    this.fromMon = props.fromMon;
    this.fromYr = props.fromYr;
    this.isCurrent = props.current || false;
    if (this.isCurrent) {
      const dt: Date = new Date();
      this.toMon = dt.getMonth() + 1;
      this.toYr = dt.getFullYear();
    } else {
      this.toMon = props.toMon;
      this.toYr = props.toYr;
    }
  }
  private getMonths(): JSX.Element[] {
    const months: JSX.Element[] = [];
    this.props.store.localization.fields.months.map((m: IMonth, i: number): void => {
      months.push(<MenuItem key={i} value={m.ndx}>{m.mon}</MenuItem>);
    });
    return months;
  }
  private getYears(): JSX.Element[] {
    const yrs: JSX.Element[] = [];
    let start: number = 0;
    let end: number = 0;
    if (this.props.fwd) {
      start = new Date().getFullYear();
      end = start + 30;
      for (let i: number = start; i <= end; ++i) {
        yrs.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
      }
    } else {
      start = new Date().getFullYear();
      end = start - 50;
      for (let i: number = start; i >= end; --i) {
        yrs.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
      }
    }
    return yrs;
  }
  @action onChangeFromMon = (evt: any): void => {
    this.fromMon = evt.target.value;
    if (this.fromYr === this.toYr && this.fromMon > this.toMon) {
      this.toMon = this.fromMon;
      this.props.onChange(this.toMon, MMYYPickValue.ToMon);
    }
    this.props.onChange(this.fromMon, MMYYPickValue.FromMon);
  }
  @action onChangeFromYear = (evt: any): void => {
    this.fromYr = Math.min(this.toYr, evt.target.value);
    if (this.fromYr === this.toYr && this.fromMon > this.toMon) {
      this.fromMon = this.toMon;
      this.props.onChange(this.fromMon, MMYYPickValue.FromMon)
    }
    this.props.onChange(this.fromYr, MMYYPickValue.FromYear);
  }
  @action onChangeToMon = (evt: any): void => {
    this.toMon = evt.target.value;
    if (this.fromYr === this.toYr && this.fromMon > this.toMon) {
      this.fromMon = this.toMon;
      this.props.onChange(this.fromMon, MMYYPickValue.FromMon);
    }
    this.props.onChange(this.toMon, MMYYPickValue.ToMon);
  }
  @action onChangeToYear = (evt: any): void => {
    this.toYr = Math.max(this.fromYr, evt.target.value);
    if (this.toYr === this.fromYr && this.toMon < this.fromMon) {
      this.toMon = this.fromMon;
      this.props.onChange(this.toMon, MMYYPickValue.ToMon);
    }
    this.props.onChange(this.toYr, MMYYPickValue.ToYear);
  }
  @action setCurrent = (evt: any, chk: boolean): void => {
    this.isCurrent = chk;
    if (this.isCurrent) {
      const dt: Date = new Date();
      this.toYr = dt.getFullYear();
      this.toMon = dt.getMonth() + 1;
      this.props.onChange(this.toMon, MMYYPickValue.ToMon);
      this.props.onChange(this.toYr, MMYYPickValue.ToYear);
    }
    this.props.onChange(this.isCurrent ? 1 : 0, MMYYPickValue.Current);
  }
  render(): JSX.Element {
    const checked: any = { color: "#5B6770" };
    const bold: any = { fontWeight: 600 };
    const disabled: boolean = this.props.currentLabel && this.props.current && this.isCurrent;
    return (<div>
      {this.props.title && <p className={s.smallText}>{this.props.title}</p>}
      <Row>
        <Col xs={3} className={s.col}>
          <FormControl>
            <InputLabel style={bold} htmlFor="from-mon">{this.props.fromLabel}</InputLabel>
            <Select input={<Input id="from-mon" />} value={this.fromMon} onChange={this.onChangeFromMon}>
              {this.getMonths()}
            </Select>
          </FormControl>
        </Col>
        <Col xs={3} className={s.col}>
          <FormControl>
            <InputLabel htmlFor="from-yr">&nbsp;</InputLabel>
            <Select input={<Input id="from-yr" />} value={this.fromYr} onChange={this.onChangeFromYear}>
              {this.getYears()}
            </Select>
          </FormControl>
        </Col>
        <Col xs={3} className={s.col}>
          <FormControl>
            <InputLabel style={bold} htmlFor="to-mon">{this.props.toLabel}</InputLabel>
            <Select input={<Input id="to-mon" />} value={this.toMon} onChange={this.onChangeToMon} disabled={disabled}>
              {this.getMonths()}
            </Select>
          </FormControl>
        </Col>
        <Col xs={3} className={s.col}>
          <FormControl>
            <InputLabel htmlFor="to-yr">&nbsp;</InputLabel>
            <Select input={<Input id="to-yr" />} value={this.toYr} onChange={this.onChangeToYear} disabled={disabled}>
              {this.getYears()}
            </Select>
          </FormControl>
        </Col>
      </Row>
      {this.props.currentLabel && <Row>
        <Col xs={12} className={s.col}>
          <FormControlLabel style={bold} label={this.props.currentLabel}
            control={<CheckBox style={checked} checked={this.isCurrent} color="secondary"
              onChange={this.setCurrent} />} />
        </Col>
      </Row>}
    </div>);
  }
}


// WEBPACK FOOTER //
// ./src/components/widgets/mmyyPicker/index.tsx